export default "__VITE_ASSET__C9$ikUB9__"